import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterPVenta'
})
export class FilterPVentaPipe implements PipeTransform {

  transform(value: any[], args?: string): any[] {
    if (!args || !value) return value;

    const filterValue = args.toLowerCase();

    return value.filter(el => {
      return (
        (el.sDesLargo03?.toLowerCase().includes(filterValue)) || // Municipio
        (el.sDesCorto01?.toLowerCase().includes(filterValue)) || // Zona
        (el.sDesLargo02?.toLowerCase().includes(filterValue)) || // Dirección
        (el.sCodigo01?.toLowerCase().includes(filterValue)) ||   // Comercio
        (el.sDesLargo04?.toLowerCase().includes(filterValue))    // Punto de referencia
      );
    });
  }
}
